import { render } from "./AllocationsView.vue?vue&type=template&id=46e6c868&scoped=true"
import script from "./AllocationsView.vue?vue&type=script&lang=js"
export * from "./AllocationsView.vue?vue&type=script&lang=js"

import "./AllocationsView.vue?vue&type=style&index=0&id=46e6c868&lang=sass&scoped=true"
script.render = render
script.__scopeId = "data-v-46e6c868"

export default script